import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _RemoteAbstractAction, _single, _SystemPropertyOB } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { SelectBudgetResourceForYear } from "../../../../../../admin/configuracion/BudgetResource/BudgetResourceForYear";
import { SelectBudgetSourceForYear } from "../../../../../../admin/configuracion/BudgetSource/SelectBudgetSourceForYear";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { SelectBudgetID } from "../../../../../../admin/configuracion/BudgetID/SelectBudgetID";
import { SelectBudgetType } from "../../../../../../admin/configuracion/select/SelectBudgetType";
import { _BudgetSource } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { AdquisitionItemSelector } from "../../../../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import useModal, { MODAL_md } from "../../../../../../theme/Component/hooks/useModal";

interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const CDPAdjustmentAction = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_RemoteAbstractAction);
    const _budgetSource = useDataBean(_BudgetSource);
    const [adquisitionItem, setAdquisitionItem] = useState<any>({});


    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalAdd, setModalAdd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [prevBean, setPrevBean] = useState<any>(null);
    const modalRubro = useModal("Cambiar Rubro", MODAL_md);

    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Saldo del Rubro', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor de la Apropiación', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Presupuesto', property: 'BudgetTypeName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Referencia', property: 'Reference', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ];

    const _systemProperties = useDataBean(_SystemPropertyOB);
    const [changeBudget, setChangeBudget] = useState(false);

    useEffect(() => {
        _systemProperties.instance.getSystemProperty("ChangeBudget").then(resp => {
            if (resp)
                setChangeBudget(resp.SystemValue == 'true');

        });

        if (data.BudgetList.DefaultValue) {
            data.BudgetList.DefaultValue.forEach(element => {
                element.DataBeanProperties.IndexID=_single.getRandomInt();
            });
            setLista(data.BudgetList.DefaultValue)
        }
    }, [data.BudgetList])

    const eliminarItem = () => {
        const updatedLista = lista.filter((bRow: any) =>
            JSON.stringify(bRow.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setLista(updatedLista);
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: data.BudgetList.Editable, evento: () => { setModal({ ...modal, "view": true, "name": `Editar Rubro ${bean.BudgetIDName ?? ""}` }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { eliminarItem() } },
            { titulo: 'Cambiar rubro', icono: 'ri-arrow-up-down-line', visible: changeBudget, evento: () => { modalRubro.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createNewItem = () => {

        const updatedLista = lista.filter((bRow: any) =>
            JSON.stringify(bRow.DataBeanProperties) !== JSON.stringify(prevBean)
        );

        _budgetSource.instance.createBudgetRowCDPItem(properties.DocumentDate, data.IDBudgetType.DefaultValue, bean.BudgetIDStr, bean.IDBudgetResource, bean.IDBudgetSource, bean.Value, bean.Description, adquisitionItem.IDAdquisitionItem ?? null, adquisitionItem?.CodeItem ?? null).then(
            (resp: any) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModal({ ...modal, "view": false })
                setModalAdd({ ...modalAdd, "view": false })
            }
        ).catch(err => toast.error(err))
    }


    const setRowBean = (e) => {
        console.log(e)
        setBean(e);
        setPrevBean(e);
    };

    const submitForm = () => {

        let key = Object.keys(data);
        console.log({ [key[1]]: lista });

        if (setData) {
            setData({ [key[1]]: lista });
        }
    }

    const createItem = () => {
        setBean({});
        setPrevBean({})
        setModalAdd({ ...modalAdd, "view": true, "name": "Crear" })
    }
    const updateBudgetCause = (index:number,budget:any) => {

        console.log(index,budget);
        

        lista.forEach(element => {
                if(element.DataBeanProperties.IndexID == index){
                    element.DataBeanProperties.BudgetIDStr = budget.JsonCode;
                    element.DataBeanProperties.BudgetName = budget.JsonCode+" - "+budget.Name;
                }
        });
        setLista([...lista]);
       
    }

    

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: createItem }
    ]

    return (
        <div className="row">
            {/* <PrintJson json={data} /> */}
            <div className="col-md-12">
                <label>{data.BudgetList.Name}</label>
            </div>
            <div className="col-md-12">
                <label>{data.IDBudgetType.Name}: {data.IDBudgetType.RenderizedObject}</label>
            </div>
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setRowBean} listButtons={listaBotones()} />
            </div>

            <div className="col-md-12">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Guardar</BasicButton>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={createNewItem} >
                    <div className="row">
                      
                        <div className="col-md-12">
                            <SelectBudgetResourceForYear config={{
                                date: properties.DocumentDate,
                                budget: bean.BudgetIDStr,
                            }} idSelector={bean.IDBudgetResource} onChange={(e) => { setBean({ ...bean, "IDBudgetResource": e, "IDBudgetSource": null, "Value": 0 }) }} />
                        </div>

                        <div className="col-md-12">
                            <SelectBudgetSourceForYear idSelector={bean.IDBudgetSource} onChange={(e) => { setBean({ ...bean, "IDBudgetSource": e }) }} cProps={{
                                budgetIDSTr: bean.BudgetIDStr,
                                budgetResource: bean.IDBudgetResource,
                                date: properties.DocumentDate,
                            }} />
                        </div>
                        <div className="col-md-12">
                            <InputMoney _label='Valor de la Apropiación' _value={bean.Value} onChange={(e: any) => { setBean({ ...bean, 'Value': e }) }} />
                        </div>
                        <hr className="mt-3" />
                        <div className="col-md-12">
                            <AdquisitionItemSelector idAdquisitionItem={adquisitionItem.IDAdquisitionItem} onChage={(e) => { setAdquisitionItem(e) }} ConfigProps={{ label: "Necesidad Seleccionada", notSeeProps: true }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalRubro.modal} updateModal={modalRubro.setModal} >
                    <div className="col-md-12">
                        <SelectBudgetID  onChange={(e) => {  updateBudgetCause(bean.IndexID,e);console.log(e);
                         }} jsonCode={bean.BudgetIDStr} edit={false} />
                    </div>
                </Modal>
                <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={createNewItem} >
                    <div className="row">
                        <>
                            <div className="col-md-12">
                                <SelectBudgetID onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }); console.log(e) }} jsonCode={bean.BudgetIDStr} edit={false} />
                            </div>
                            {bean.BudgetIDStr &&
                                <div className="col-md-12">
                                    <SelectBudgetResourceForYear config={{
                                        date: properties.DocumentDate,
                                        budget: bean.BudgetIDStr,
                                    }} idSelector={bean.IDBudgetResource} onChange={(e) => { setBean({ ...bean, "IDBudgetResource": e }) }} />
                                </div>
                            }
                            {bean.IDBudgetResource &&
                                <div className="col-md-12">
                                    <SelectBudgetSourceForYear idSelector={bean.IDBudgetSource} onChange={(e) => { setBean({ ...bean, "IDBudgetSource": e }) }} cProps={{
                                        budgetIDSTr: bean.BudgetIDStr,
                                        budgetResource: bean.IDBudgetResource,
                                        date: properties.DocumentDate,
                                    }} />
                                </div>
                            }
                            <div className="col-md-12">
                                <InputMoney _label='Valor de la Apropiación' _value={bean.Value} onChange={(e: any) => { setBean({ ...bean, 'Value': e }) }} />
                            </div>
                        </>
                        <hr className="mt-3" />
                        <div className="col-md-12">
                            <AdquisitionItemSelector idAdquisitionItem={adquisitionItem.IDAdquisitionItem} onChage={(e) => { setAdquisitionItem(e) }} ConfigProps={{ label: "Necesidad Seleccionada", notSeeProps: true }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}